import React from "react";
import { Link, useLocation } from 'react-router-dom';
import styles from './Navigation.module.css';
import logo from '../Assets/HT logo round.png';
const Navigation = () => {
    const location = useLocation();
    
    return (
        <div className={styles.navigation}>
            <div className={styles.navbar}>
                <div className={styles.logo}>Hyzerberg Technologies</div>
                <img className={styles.ht} src={logo} alt="HT logo"></img>
            </div>
            
            
            
            <div className={styles.links}>
                <Link 
                to="/" 
                className={location.pathname === '/' ? `${styles.link} ${styles.active}` : styles.link}>
                Home
                </Link>
                <Link 
                to="/about" 
                className={location.pathname === '/about' ? `${styles.link} ${styles.active}` : styles.link}>
                About
                </Link>
                <Link
                to="/status"
                className={location.pathname === '/status' ? `${styles.link} ${styles.active}` : styles.link}
                >
                Current Status
                </Link>
                <Link
                to="/team"
                className={location.pathname === '/team' ? `${styles.link} ${styles.active}` : styles.link}
                >
                Meet the Team
                </Link>
            </div>
        </div>
    )
}

export default Navigation;